import { fire_notification_for_every_message } from "@/graphql/mutations.js";
import { API, graphqlOperation } from "aws-amplify";
// import { GetAllMessages } from "@/mixins/Chat/ListMessages.js";

export const FireNotification = {
  //   mixins: [GetAllMessages],
  data() {
    return {
      GetAllViolationsList: [],
      overlay: false,
      user_type: "",
      ChatsList: [],
    };
  },
  methods: {
    async FireNotificationMethod() {
      try {
        let inputParams = {
          motorist_user_id: this.$store.getters.get_motorist_name.user_id,
          police_user_id: this.$store.getters.get_current_user_details.user_id,
        };
        let result = await API.graphql(
          graphqlOperation(fire_notification_for_every_message, {
            input: inputParams,
          })
        );
      } catch (error) {
        console.log("Check error", error);
      }
    },
  },
};
